(function(){
    'use strict'

    angular.module('app.bancos')
    .factory('BancosService', BancosService);

    BancosService.$inject = ['$http', '$q', 'apiSettings'];

    function BancosService($http, $q, apiSettings) {

        var api = {
            getAll: getAll,
            getById: getById,
            save: save,
            update:update,
            remove: remove
        };

        return api;

        function getAll(){

            var url = apiSettings.apiBaseUrl + 'api/bancos';
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getById(bancoId){

            var url = apiSettings.apiBaseUrl + 'api/bancos/' + bancoId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(banco){

            banco.id = 0;

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/bancos',  
                method: 'POST',  
                data: banco
            });  
            return response;
        };

        function update(banco){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/bancos',  
                method: 'PUT',  
                data: banco
            });  
            return response;
        };

        function remove(banco){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/bancos',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: banco
            });  
            return response;
        };

    };

})();